import { useTenant } from "hooks/settings";
import { useMemo } from "react";
import {
  ScrapEyeInstallationLocation,
  useListInstallationLocationsQuery,
} from "src/store/api/generatedApi";

type LabellingLocations = Readonly<{
  locations: readonly ScrapEyeInstallationLocation[];
  locationNames: readonly string[];
  isLoading: boolean;
}>;

const NO_LOCATIONS: readonly ScrapEyeInstallationLocation[] = [];

/** The site's labelling locations, in the order the installation endpoint gives them. */
export const useLabellingLocations = (): LabellingLocations => {
  const tenantName = useTenant();
  const { data, isLoading } = useListInstallationLocationsQuery({
    tenantName,
    locationTypes: ["labelling"],
  });

  const locations = data ?? NO_LOCATIONS;

  const locationNames = useMemo(
    () => locations.map((location) => location.name),
    [locations]
  );

  return { locations, locationNames, isLoading };
};
